module.exports = __webpack_public_path__ + "static/media/Spinner.b24040d4.svg";